import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import type { PropType } from 'vue';
import type { CompanyStatus } from '@/types/company';
import { COMPANY_STATUS_MAP } from '@/types/company';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyStatusTag',
  props: {
  status: {
    type: String as PropType<CompanyStatus>,
    required: true
  },
  effect: {
    type: String as PropType<'light' | 'dark' | 'plain'>,
    default: 'light'
  },
  size: {
    type: String as PropType<'large' | 'default' | 'small'>,
    default: 'default'
  }
},
  setup(__props) {

const props = __props;

const getTagType = (status: CompanyStatus) => {
  switch (status) {
    case 'planned':
      return 'info';
    case 'submitted':
      return 'primary';
    case 'interviewing':
      return 'warning';
    case 'offered':
      return 'success';
    case 'accepted':
      return 'success';
    case 'rejected':
      return 'danger';
    default:
      return 'info';
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(_component_el_tag, {
    type: getTagType(__props.status),
    effect: __props.effect,
    size: __props.size,
    class: "company-status-tag"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(COMPANY_STATUS_MAP)[__props.status]), 1)
    ]),
    _: 1
  }, 8, ["type", "effect", "size"]))
}
}

})